import { LauncherElementType } from './launcherElementInfo';

interface ToolbarInfo {
  elementType: LauncherElementType;
  tooltip: string;
}

export const toolbarInfo: ToolbarInfo[] = [
  { elementType: 'div', tooltip: 'Box Element' },
  { elementType: 'button', tooltip: 'Button Element' },
  { elementType: 'popup', tooltip: 'Popup Element' },
  // TODO: add back
  // { elementType: 'licensePopup', tooltip: 'License Popup Element' },
  // { elementType: 'targetVariableInput', tooltip: 'Input Element' },
  { elementType: 'text', tooltip: 'Text Element' },
  { elementType: 'link', tooltip: 'Link Element' },
  { elementType: 'variableText', tooltip: 'Variable Text Element' },
  { elementType: 'img', tooltip: 'Image Element' },
  { elementType: 'appTaskProgressBar', tooltip: 'Progress Bar Element' },
  // { elementType: 'appChangelog', tooltip: 'App Changelog Element' }, // TODO: add back
  { elementType: 'iframe', tooltip: 'Iframe Element' },
];
